import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from '../../service/local-storage.service';
import { MainService } from '../../service/main.service';
import { ToasterServiceService } from '../../service/toaster.service';
import { ApiUrls } from '../../apiRouts';
import { DatePipe } from '@angular/common';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-medicine-reminder',
  templateUrl: './medicine-reminder.component.html',
  styleUrl: './medicine-reminder.component.scss'
})
export class MedicineReminderComponent implements OnInit{
  medicineReminderForm: any = FormGroup;
  buttonclick: boolean = false;
  medicineHistoryData: any;
  submitted = false;
  userId: any;
  @ViewChild('formContainer') formContainer!: ElementRef;
  datePipe = new DatePipe("en-US")

  constructor(
    private fb: FormBuilder,
    private renderer: Renderer2,
    private localStorageService: LocalStorageService,
    private mainService: MainService,
    public dialog: MatDialog,
    private toasterService: ToasterServiceService
  ) {
    this.userId = JSON.parse(localStorageService.getItem("loginData") || '{}').user_id;
    this.medicineReminderForm = this.fb.group({
      medicine_reminder_id: [0],
      start_time: ['', Validators.required],
      remarks: [''],
    })
  }

  ngOnInit() {
    this.getMedicineList();
  }

  get f() {
    return this.medicineReminderForm.controls;
  }

  getMedicineList() {
    this.mainService.getApi(ApiUrls.medicineSleep + this.userId).subscribe((res: any) => {
      if (res.status === 1) {
        this.medicineHistoryData = res.medicine_reminder.map((item: any) => ({
          ...item,
          is_active: +item.is_active,
          start_time: this.convertTo12HourFormat(item.start_time),
        }));
      }
    });
  }

  convertTo12HourFormat(time: string): string {
    const [hour, minute, second] = time.split(':');
    const period = +hour >= 12 ? 'PM' : 'AM';
    const hour12 = +hour % 12 || 12;
    return `${hour12}:${minute} ${period}`;
  }
  
  editMedicineData(data: any) {
    this.buttonclick = true;
    const startTime = this.extractHourAndMinute(data.start_time);
    this.medicineReminderForm.patchValue({
      start_time: startTime,
      remarks: data.remarks,
      medicine_reminder_id: data.medicine_reminder_id,
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      if (this.formContainer && this.formContainer.nativeElement) {
        this.renderer.selectRootElement(this.formContainer.nativeElement).focus();
      }
    }, 300);
  }

  extractHourAndMinute(time: string): string {
    const [hourMinute, amPm] = time.split(' ');
    const [hour, minute] = hourMinute.split(':');
    return `${hour}:${minute} ${amPm}`;
  }

  openDialog(e: any, data: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.deleteMedicineData(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  deleteMedicineData(value: any) {
    let data = {
      medicine_reminder_id: Number(value.medicine_reminder_id),
      user_id: this.userId,
      start_time: "",
      remarks: "",
      is_active: String(value.is_active ? 1 : 0),
      Action: 'IS_ACTIVE',
    };
    this.mainService.postApi(ApiUrls.medicineStatus, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getMedicineList();
      } else {
        this.toasterService.toastError(res.response);
      }
    });
  }

  private convertTimeTo24HourFormat(time: string): string {
    let [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (modifier === 'PM' && hours < 12) {
      hours += 12;
    } else if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    let formattedHours = hours.toString().padStart(2, '0');
    let formattedMinutes = minutes.toString().padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}:00`;
  }

  addMedicineReminder() {
    this.submitted = true;
    if (this.medicineReminderForm.valid) {
      let startTime = this.medicineReminderForm.value.start_time;
      let formattedTime = this.convertTimeTo24HourFormat(startTime);
      let data = {
        medicine_reminder_id: 0,
        user_id: this.userId,
        start_time: formattedTime,
        remarks: this.medicineReminderForm.value.remarks,
        is_active: "1",
        Action: "INSERT",
      };
      this.mainService.postApi(ApiUrls.addEditMedicineReminder, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.medicineReminderForm.reset();
          this.submitted = false;
          this.getMedicineList();
          this.toasterService.toastSuccess(res.response);
        } else {
          this.toasterService.toastError(res.response);
        }
      })
    }
    else {
      this.submitted = true;
    }
  }

  editMedicineReminder() {
    let startTime = this.medicineReminderForm.value.start_time;
    let formattedTime = this.convertTimeTo24HourFormat(startTime);
    let data = {
      medicine_reminder_id: this.medicineReminderForm.value.medicine_reminder_id,
      user_id: this.userId,
      start_time: formattedTime,
      remarks: this.medicineReminderForm.value.remarks,
      is_active: "1",
      Action: "UPDATE",
    };
    if (this.medicineReminderForm.valid) {
      this.mainService.putApi(ApiUrls.addEditMedicineReminder, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.getMedicineList();
          this.medicineReminderForm.reset();
          this.submitted = false;
          this.buttonclick = false;
        }
      });
    } else {
      this.submitted = true
      this.buttonclick = true;
    }
  }

}
